import "twin.macro";

import { Edit } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import { OpaqueCard } from "@components/StyledComponents";
import IndexTable from "@features/ui/indexTable";
import { Brand } from "@models/Brand";

import { useBrandsListQuery } from "../data";

const BrandManagementTable = ({
  onEdit,
}: {
  onEdit: (brand: Brand) => void;
}) => {
  const { data: brands = [], error, isLoading } = useBrandsListQuery();
  return (
    <OpaqueCard tw="p-0">
      <IndexTable
        maxHeight={400}
        columns={[
          {
            id: "id",
            label: "ID",
          },
          {
            id: "name",
            label: "Brand Name",
          },
          {
            id: "_action",
            align: "right",
            label: "",
            render: (_, row) => (
              <IconButton onClick={() => onEdit(row)} tw="-my-2">
                <Edit />
              </IconButton>
            ),
          },
        ]}
        rows={brands}
        error={error}
        isLoading={isLoading}
      />
    </OpaqueCard>
  );
};

export default BrandManagementTable;
